import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import PlantSuggestions from './pages/PlantSuggestions';
import EnvironmentImpact from './pages/EnvironmentImpact';
import About from './pages/About';
import AIDoctor from './pages/AIDoctor';
import Login from './components/Login';
import ProtectedLayout from './components/ProtectedLayout';
import { AuthProvider } from './components/AuthContext';
import './styles/App.css';
import ClimateImpact from './pages/ClimateImpact';
import EcoReport from './pages/GardenEcoReport';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <div className="app-container">
          <Routes>
            {/* Public route - Login page */}
            <Route path="/login" element={<Login />} />
            
            {/* Protected routes - nested under ProtectedLayout */}
            <Route element={<ProtectedLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/about" element={<About />} />
              <Route path="/find-plants" element={<PlantSuggestions />} />
              {/* <Route path="/environment-impact" element={<EnvironmentImpact />} /> */}
              <Route path="/ai-doctor" element={<AIDoctor />} />
              {/* <Route path="/climate-impact" element={<ClimateImpact />} /> */}
              <Route path="/report" element={<EcoReport />} />
              <Route path="*" element={
                <div style={{ padding: '6rem 2rem 2rem' }}>
                  <h1>404</h1>
                  <p>Page not found</p>
                </div>
              } />
            </Route>
            
            {/* Redirect any unknown routes to login */}
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </div>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;